<script lang="ts">
	import { t } from 'svelte-i18n';
	import Rating from '$lib/components/Rating.svelte';

	export let rating: number;
	export let onClick: () => void = null;
	export let currentRating: number;
	export let hasAlreadyVoted = false;

	const items = [
		{
			value: 1,
			tooltip: $t('ratingProject.1')
		},
		{
			value: 2,
			tooltip: $t('ratingProject.2')
		},
		{
			value: 3,
			tooltip: $t('ratingProject.3')
		},
		{
			value: 4,
			tooltip: $t('ratingProject.4')
		},
		{
			value: 5,
			tooltip: $t('ratingProject.5')
		}
	];
</script>

<Rating color="warning" {items} {rating} on:click={onClick} bind:currentRating {hasAlreadyVoted} />
